import { render, staticRenderFns } from "./VoiceRecognitionDialog.vue?vue&type=template&id=1db1ed47&scoped=true&"
import script from "./VoiceRecognitionDialog.vue?vue&type=script&lang=js&"
export * from "./VoiceRecognitionDialog.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecognitionDialog.vue?vue&type=style&index=0&id=1db1ed47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1ed47",
  null
  
)

export default component.exports